require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./tags-الفوتوشوب.json") })
        }
      }, "path---tags-الفوتوشوب");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---tags-الفوتوشوب!./.cache/json/tags-الفوتوشوب.json
// module id = 581
// module chunks = 231608221292675